import { RenderUnsettledUI } from 'shared/components';
import { useSiteDetection } from 'shared/hooks';
import { AnalyticsSection } from './analytics';
import { useGetApplicationsPendingReview } from '../../../../../../api/hooks/dashboard/analytics/use-get-applications-pending-review';
import { useGetApplicationAverageReactionTime } from '../../../../../../api/hooks/dashboard/analytics/use-get-application-average-reaction-time';
import { useGetDaysPlannedAhead } from '../../../../../../api/hooks/dashboard/analytics/use-get-days-planned-ahead';
import { useGetCheckoutsPendingReview } from '../../../../../../api/hooks/dashboard/analytics/use-get-checkouts-pending-review';
import { useGetFillRateOfUpcomingShifts } from '../../../../../../api/hooks/dashboard/analytics/use-get-fill-rate-of-upcoming-shifts';
import { useGetFillRateForFlexPoolWorkers } from '../../../../../../api/hooks/dashboard/analytics/use-get-fill-rate-for-flex-pool-workers';
import { useGetMedianShiftPublishingWindow } from '../../../../../../api/hooks/dashboard/analytics/use-get-median-shift-publishing-window';
import { useGetCheckoutsAverageAcceptanceTime } from '../../../../../../api/hooks/dashboard/analytics/use-get-checkouts-average-acceptance-time';

export const AnalyticsSectionDataProvider = () => {
  const { site } = useSiteDetection();
  const getApplicationAverageReactionTimeQuery = useGetApplicationAverageReactionTime(site);
  const getDaysPlannedAheadQuery = useGetDaysPlannedAhead(site);
  const getCheckoutsPendingReviewQuery = useGetCheckoutsPendingReview(site);
  const getApplicationsPendingReviewQuery = useGetApplicationsPendingReview(site);
  const getFillRateOfUpcomingShiftsQuery = useGetFillRateOfUpcomingShifts(site);
  const getFillRateForFlexPoolWorkersQuery = useGetFillRateForFlexPoolWorkers(site);
  const getMedianTimeShiftPublishingWindowQuery = useGetMedianShiftPublishingWindow(site);
  const getCheckoutsAverageAcceptanceTimeQuery = useGetCheckoutsAverageAcceptanceTime(site);

  if (getApplicationAverageReactionTimeQuery.isError) {
    return <RenderUnsettledUI data={getApplicationAverageReactionTimeQuery} />;
  }

  if (getDaysPlannedAheadQuery.isError) {
    return <RenderUnsettledUI data={getDaysPlannedAheadQuery} />;
  }

  if (getCheckoutsPendingReviewQuery.isError) {
    return <RenderUnsettledUI data={getCheckoutsPendingReviewQuery} />;
  }

  if (getApplicationsPendingReviewQuery.isError) {
    return <RenderUnsettledUI data={getApplicationsPendingReviewQuery} />;
  }

  if (getFillRateOfUpcomingShiftsQuery.isError) {
    return <RenderUnsettledUI data={getFillRateOfUpcomingShiftsQuery} />;
  }

  if (getFillRateForFlexPoolWorkersQuery.isError) {
    return <RenderUnsettledUI data={getFillRateForFlexPoolWorkersQuery} />;
  }

  if (getMedianTimeShiftPublishingWindowQuery.isError) {
    return <RenderUnsettledUI data={getMedianTimeShiftPublishingWindowQuery} />;
  }

  if (getCheckoutsAverageAcceptanceTimeQuery.isError) {
    return <RenderUnsettledUI data={getCheckoutsAverageAcceptanceTimeQuery} />;
  }

  return (
    <AnalyticsSection
      data={{
        ...getApplicationAverageReactionTimeQuery.data,
        ...getDaysPlannedAheadQuery.data,
        ...getCheckoutsPendingReviewQuery.data,
        ...getApplicationsPendingReviewQuery.data,
        ...getFillRateOfUpcomingShiftsQuery.data,
        ...getFillRateForFlexPoolWorkersQuery.data,
        ...getMedianTimeShiftPublishingWindowQuery.data,
        ...getCheckoutsAverageAcceptanceTimeQuery.data,
      }}
    />
  );
};
